<thm-checkbox #parent class="aof-checkbox"
  inputId="inputId" [value]="value"
  [inline]="inline" [disabled]="disabled" labelAlign="labelAlign" 
  (valueChange)="onChange($event)" (clearError)="onChange($event)"> 
  {{labelText}}
</thm-checkbox> 